import React from 'react'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'
import { useTranslation } from 'react-i18next'

const ViewToggle = ({ value, onChange }) => {
  const { t } = useTranslation()
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(e, v) => { if (v) onChange(v) }}
    >
      <ToggleButton value="projetos">{t('creditosDeBiodiversidade.modoProjetos')}</ToggleButton>
      <ToggleButton value="titulos">{t('creditosDeBiodiversidade.modoTitulos')}</ToggleButton>
    </ToggleButtonGroup>
  )
}

export default ViewToggle
